import { render, staticRenderFns } from "./Record.vue?vue&type=template&id=8d28811c&"
import script from "@/controllers/admin/rollcall/Record?v=2.0?vue&type=script&lang=ts&"
export * from "@/controllers/admin/rollcall/Record?v=2.0?vue&type=script&lang=ts&"
import style0 from "@/assets/css/backend.css?v=2.2?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports